import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cc5e908"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session" }
const _hoisted_2 = {
  key: 0,
  class: "text-center mt-5 pt-5"
}
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("MEDA "),
  /*#__PURE__*/_createElementVNode("span", null, "FORTBILDUNGEN")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Bitte geben Sie die folgenden Informationen an:", -1))
const _hoisted_6 = { class: "floating-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "Vorname", -1))
const _hoisted_8 = { class: "floating-label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, "Nachname", -1))
const _hoisted_10 = {
  key: 0,
  class: "consent-row"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Ich willige in die Verarbeitung meiner Daten gemäß der "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.meda-fortbildungen.de/datenschutz",
    target: "_blank",
    rel: "noopener"
  }, "Datenschutzerklärung"),
  /*#__PURE__*/_createTextVNode(" ein. ")
], -1))
const _hoisted_12 = ["disabled"]

import { reactive, computed, watch } from "vue"
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import { TUser } from '@/types/TUser'

export default /*#__PURE__*/_defineComponent({
  __name: 'UserForm',
  setup(__props) {

const router = useRouter();
const store = useStore()

const user: TUser = reactive({ first_name: '', last_name: '', consentGiven: false })

// Vorbefüllen aus dem geladenen Profil: die Namen kommen ggf. schon aus dem
// Anlegen durch die Einrichtung, dann fehlt hier nur noch die Einwilligung.
// Reaktiv, weil das Formular mounten kann, bevor das Profil geladen ist.
const profileDraft = computed(() => store.getters.getProfileDraft)
watch(profileDraft, (draft) => {
  if (!draft) return
  if (!user.first_name) user.first_name = draft.first_name || ''
  if (!user.last_name) user.last_name = draft.last_name || ''
}, { immediate: true })

// Bereits erteilte Einwilligung (z. B. durch die Einrichtung bei der Einladung)
const consentAlreadyGiven = computed(() => profileDraft.value?.consentGiven === true)
const error = computed(() => !user.first_name || !user.last_name || (!consentAlreadyGiven.value && !user.consentGiven))
const loaded = computed(() => store.getters.getUserDetailsLoaded);

async function saveUser () {
  if (!error.value) {
    try {
      const result = await store.dispatch('saveUser', {
        ...user,
        // Eine bereits vorliegende Einwilligung darf hier nicht überschrieben werden
        consentGiven: consentAlreadyGiven.value ? true : user.consentGiven,
      })
      result && router.push({ name: 'home' })
    } catch (error) {
      console.log(error)
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(loaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(loaded))
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _withModifiers(saveUser, ["prevent"])
        }, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              placeholder: "Vorname",
              type: "text",
              name: "firstname",
              id: "firstname",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.first_name) = $event))
            }, null, 512), [
              [_vModelText, user.first_name]
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              placeholder: "Nachname",
              type: "text",
              name: "lastname",
              id: "lastname",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.last_name) = $event))
            }, null, 512), [
              [_vModelText, user.last_name]
            ]),
            _hoisted_9
          ]),
          (!_unref(consentAlreadyGiven))
            ? (_openBlock(), _createElementBlock("label", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.consentGiven) = $event))
                }, null, 512), [
                  [_vModelCheckbox, user.consentGiven]
                ]),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "continue-btn",
            disabled: _unref(error)
          }, "Weiter", 8, _hoisted_12)
        ], 40, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})